import React from 'react'
import {Tag} from 'antd'
import {Link} from 'react-router-dom'
import {LOYALTY_STATUSES} from '../../helpers/misc'

export function LoyaltyStatusTag({status, className = '', linkTo = null}) {
  const level = typeof status === 'string' ? LOYALTY_STATUSES[status.toUpperCase()] : status

  if (!level || !level.name)
    return <Tag className="loyalty-status-tag loyalty-status-tag-placeholder">
      &nbsp;
    </Tag>

  const style = {
    ...(level.color && {backgroundColor: level.color, borderColor: level.color}),
    ...(level.text_color && {color: level.text_color})
  }

  const tag = (
    <Tag
      className={`loyalty-status-tag ${className}`.trim()}
      style={style}
    >
      {level.name}
    </Tag>
  )

  return linkTo ? <Link to={linkTo} className="loyalty-status-tag-link">{tag}</Link> : tag
}
